import { render, staticRenderFns } from "./StartupHeader.vue?vue&type=template&id=d8839468&scoped=true&"
import script from "./StartupHeader.vue?vue&type=script&lang=js&"
export * from "./StartupHeader.vue?vue&type=script&lang=js&"
import style0 from "./StartupHeader.vue?vue&type=style&index=0&id=d8839468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8839468",
  null
  
)

export default component.exports